export const getPhoneFragment = (
  event: React.ChangeEvent<HTMLInputElement>,
  onChange: (e: { target: { name: string; value: string } }) => void,
  name: string,
  maxLength: number,
  format: number[],
) => {
  if (!event || !onChange || !name) return;

  let newValue = event.target.value;
  newValue = formatPhoneNumber(newValue, format);

  if (newValue.replaceAll(" ", "").length <= maxLength) {
    onChange({ target: { name, value: newValue } });
  }
};

const formatPhoneNumber = (number: string, format: number[]): string => {
  if (!number || !format) return number;

  let formattedNumber = number;
  format.forEach((index) => {
    if (formattedNumber.length > index && formattedNumber[index] !== " ") {
      formattedNumber =
        formattedNumber.slice(0, index) + " " + formattedNumber.slice(index);
    }
  });

  return formattedNumber;
};

export default getPhoneFragment;
